import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actionCreator from '../../../../action/index.js';

class PricecollapseBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapse: false,
    };
  }

  handleCollapse = () => {
    this.setState((prevState) => ({
      isCollapse: !prevState.isCollapse,
    }));
  };

  render() {
    const { isCollapse } = this.state;
    const { children } = this.props;

    return (
      <div className={`price-box-collapse-wrapper ${isCollapse ? 'active' : ''}`} onClick={this.handleCollapse}>
        {children}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.reducer,
    ...state.orderExtrasReducer,
    ...state.priceUpdateReducer,
  };
};

export default connect(mapStateToProps, actionCreator)(PricecollapseBox);
